import { cn } from "cn";

export function ErrorPageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center overflow-hidden">
      {children}
      <div className="absolute bottom-10 left-0 text-center w-full">
        <div className="max-w-full overflow-hidden">
          <SFComputeAsciiWordmark />
        </div>
      </div>
    </div>
  );
}

const asciiWordmark = `
      ___           ___                    ___           ___           ___           ___         ___                         ___
     /\\__\\         /\\__\\                  /\\__\\         /\\  \\         /\\  \\         /\\  \\       /\\  \\                       /\\__\\
    /:/ _/_       /:/ _/_                /:/  /        /::\\  \\       |::\\  \\       /::\\  \\      \\:\\  \\         ___         /:/ _/_
   /:/ /\\  \\     /:/ /\\__\\              /:/  /        /:/\\:\\  \\      |:\\:\\  \\     /:/\\:\\__\\      \\:\\  \\       /\\__\\       /:/ /\\__\\
  /:/ /::\\  \\   /:/ /:/  /             /:/  /  ___   /:/  \\:\\  \\   __|:\\:\\  \\   /:/ /:/  /  ___  \\:\\  \\     /:/  /      /:/ /:/ _/_
 /:/_/:/\\:\\__\\ /:/_/:/  /             /:/__/  /\\__\\ /:/__/ \\:\\__\\ /::::|_\\:\\__\\ /:/_/:/  /  /\\  \\  \\:\\__\\   /:/__/      /:/_/:/ /\\__\\
 \\:\\/:/ /:/  / \\:\\/:/  /              \\:\\  \\ /:/  / \\:\\  \\ /:/  / \\:\\~~\\  \\/__/ \\:\\/:/  /   \\:\\  \\ /:/  /  /::\\  \\      \\:\\/:/ /:/  /
  \\::/ /:/  /   \\::/__/                \\:\\  /:/  /   \\:\\  /:/  /   \\:\\  \\        \\::/__/     \\:\\  /:/  /  /:/\\:\\  \\      \\::/_/:/  /
   \\_/:/  /     \\:\\  \\                 \\:\\/:/  /     \\:\\/:/  /     \\:\\  \\        \\:\\  \\      \\:\\/:/  /   \\/__\\:\\  \\      \\:\\/:/  /
     /:/  /       \\:\\__\\                 \\::/  /       \\::/  /       \\:\\__\\        \\:\\__\\      \\::/  /         \\:\\__\\      \\::/  /
     \\/__/         \\/__/                  \\/__/         \\/__/         \\/__/         \\/__/       \\/__/           \\/__/       \\/__/
`;

const asciiWordmarkSmall = `
  ___ ___    ___                     _
 / __| __|  / __|___ _ __  _ __ _  _| |_ ___
 \\__ | _|  | (__/ _ | '  \\| '_ | || |  _/ -_)
 |___|_|    \\___\\___|_|_|_| .__/\\_,_|\\__\\___|
                          |_|
`;

function SFComputeAsciiWordmark() {
  const Wrapper = ({
    children,
    className,
  }: {
    children: React.ReactNode;
    className: string;
  }) => (
    <pre
      className={cn(
        "text-neutral-300 text-xs font-mono whitespace-pre",
        className,
      )}
      aria-hidden="true"
      role="presentation"
    >
      {children}
    </pre>
  );

  return (
    <div className="flex flex-col w-full items-center justify-center">
      <Wrapper className="hidden sm:block">{asciiWordmark}</Wrapper>
      <Wrapper className="sm:hidden">{asciiWordmarkSmall}</Wrapper>
    </div>
  );
}
